/*------------------------------------*\
    MODAL
\*------------------------------------*/
class Modal {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.modalToggle();
    }

    modalToggle() {
        let self = this;

        const toggle = document.querySelector('[data-modal-toggle]');

        // toggle.addEventListener('click', evt => {
        //     evt.preventDefault();
        //     toggle.classList.toggle('is-open');
        // });
    }
}

export default Modal;
